module.exports = __webpack_public_path__ + "static/img/14000779.3c67d4de.png";